import React, { FunctionComponent } from 'react'

import { gtm } from '@Globals/Google/DataLayer'

interface Props {
  enabled?: boolean
}

export const UserCentricsScript: FunctionComponent<Props> = ({
  enabled = false,
}: Props) => {
  if (enabled) {
    return (
      <script
        data-settings-id="yVg5SCH8r"
        defer
        id="usercentrics-cmp"
        src="https://app.usercentrics.eu/browser-ui/latest/bundle_legacy.js"
      />
    )
  }
  gtm({ ConsentAllServices: true, event: 'consent_status' })
  return null
}
